import {ChangeDetectorRef, Component, DestroyRef, ElementRef, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild, inject, signal } from '@angular/core';
import {animate, state, style, transition, trigger} from '@angular/animations';

import { MatTableDataSource } from '@angular/material/table';
import { EntryData, SimilarStructure, Structure} from '../../entry/structure-data.models';
import { MatPaginator } from '@angular/material/paginator';
import { ConfigService } from '../../config.service';
import { ActivatedRoute } from '@angular/router';
import { CommonService } from '../../common.service';
import { GoogleAnalyticsService } from '../../google-analytics.service';
import { EntryStatusComponent } from '../../entry-status/entry-status.component';
import { MatTabChangeEvent, MatTabGroup } from '@angular/material/tabs';
import { MatSort, Sort } from '@angular/material/sort';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { DomSanitizer } from "@angular/platform-browser";
import { MatCheckboxChange } from '@angular/material/checkbox';
import { SelectionModel } from '@angular/cdk/collections';
import { HttpResponse } from '@angular/common/http';
import { PALETTE } from '../../molstar-alpha-missense';
import { CheckboxService } from '.././checkbox.service';
import { Subscription, combineLatest, map } from 'rxjs';
import * as XLSX from 'xlsx';
import { DownloadService } from '../../download-service';
import { PlatformService } from '../../platform.service';
import { MolstarPluginService } from '../../molstar-plugin-service';
import { Store } from '@ngrx/store';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { EntrySelectors } from '../../state/entry.selectors';
import { UtilService } from '../../util.service';
import { FoldseekService } from '../foldseek.service';
import { FoldseekapiService } from '../foldseekapi.service';

@Component({
  selector: 'app-bfvd-tab',
  templateUrl: './bfvd-tab.component.html',
  styleUrls: ['../allbacteria-tab/allbacteria-tab.component.css'],
  standalone: false
})
export class BfvdTabComponent implements OnInit{
  @Input() accession: string;
  @Input() afdb_accession: string;

  @Output() toggleClickedEvent: EventEmitter<Object> = new EventEmitter();


  public foldseekService = inject(FoldseekService);
  public foldseekapiService = inject(FoldseekapiService);

  hasStructureData: number;

  totalStructure: number;
  totalAFDBStructure: number;
  checked = false;
  disabled = false;
  superposeData = [];

  hasAFDBData: number;

  displayedColumnsAFDBStructure: string[] = [
    'expand', 
    'select', 
    'afdbAccessions', 
    'speciesNames', 
    'sequenceLength', 
    'evalue', 
    'sequenceIdentity', 
    'averagePlddt', 
    'alighin3D'
  ];

  afdbStructureDataSource = new MatTableDataSource<SimilarStructure>();

  isStructureCach: boolean = true;
  isStructureRunning: boolean = false;
  isStrcutureData: boolean = false;
  isStructureFail: boolean = false;

  isAFDBFoldseekCach: boolean = true;

  subTimeout:any;
  isColorby: boolean= true;
  apiData = {};
  targetColors = {};
  checkboxState: { [key: string]: boolean } = {};
  disabledState: { [key: string]: boolean } = {};
  private subscription: Subscription;
  private subscription2: Subscription;

  structure: Structure;

  molLoadComplete:boolean = false;
  viewerInstance: any = undefined;
  apiData2 = [];

  records="10";
  start="0";
  startAFDB = "0";

  errorAFDB: string;

  recordsAFDB = "10";

  currentAFDBPage = 0;

  sort_direction_AFDB='asc'; 
  sort_column_AFDB='evalue';

  species_name_filter_AFDB="";

  filteritemAFDB = "";

  afdbZeroResultsMsg = "";

  isAFDBDownloadEnabled: boolean = true;
  
  isAFDBLoading = false;
  public entryData = signal<EntryData>({} as EntryData);
  public uniprotData = signal<any>({});
  
  private readonly destroyRef = inject(DestroyRef);
  
  constructor(
    private sanitizer:DomSanitizer,
    private route: ActivatedRoute,
    private commonService: CommonService,
    public gaService: GoogleAnalyticsService,
    private configService: ConfigService,
    private changeDetectorRef: ChangeDetectorRef,
    private checkboxService: CheckboxService,
    private el: ElementRef,
    private utilService: UtilService,
    private store: Store,
    private molstarPluginService : MolstarPluginService,
    private platform: PlatformService) {
      this.hasStructureData = -1;
      this.hasAFDBData = -1;
  }

  private assignedColor: {[targetId: string]: string} = {};
  private nextColorIndex = 0;

  dropdownOptionsAFDB: { label: string, value: any, isShow: boolean, disabled?: boolean, info?: string }[];

  isDownloadFailed = false;
  isDownloadDone = false;
  isDownloadRunning = false;
  readonly MAX_SELECTION = 100;
  isLimitReachedBFVD = false;
  isDatabaseErrorBFVD = false;
  isDisabled = false;

  downloadService = inject(DownloadService);
  selectedValuesBFVD = this.downloadService.selectedValuesBFVD;
  allSelectedBFVD = this.downloadService.allSelectedBFVD;
  selectionBFVD: Set<string> = new Set<string>();

  @ViewChild('paginator3',{ static: true }) paginator3!: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('tabGroup') tabGroup: MatTabGroup;
  
  ngOnInit(): void {
    this.downloadService.updateSelectedValuesBFVD([]);
    this.subscription = this.checkboxService.checkboxState$.subscribe(state => {
      this.checkboxState = state;
      this.changeDetectorRef.detectChanges(); // Trigger change detection manually
    });

    this.checkboxService.disabledState$.subscribe(state => {
      this.disabledState = state;
    });

    this.dropdownOptionsAFDB = [
      { label: 'Search results (max 10 000)', value: "allresultscsv" , isShow: true, disabled: false},
      { label: 'Coordinates and PAE (max 100)', value: "modelcoordicate", isShow: true, disabled: true},
    ];

    combineLatest([
      this.store.select(EntrySelectors.entryData).pipe(),
      this.store.select(EntrySelectors.uniprotData).pipe(),
    ])
    .pipe(
      map(([entryData, uniprotData]) => {
        this.entryData.set(entryData)
        this.uniprotData.set(uniprotData)
        
      }),
      takeUntilDestroyed(this.destroyRef)
    )
    .subscribe((data) => {});

    this.checkAndGetBFVDData(this.recordsAFDB, this.startAFDB, this.sort_direction_AFDB, this.sort_column_AFDB, this.species_name_filter_AFDB);
  }

  ngAfterViewInit(): void {
    this.changeDetectorRef.detectChanges();
  }

  expandedElementAFDB
  expandRowAFDB(element) {
    this.expandedElementAFDB = this.expandedElementAFDB === element ? null : element
  }

  expandedElementsAFDB = [];
  toggleRowAFDB(element ) {

    const ele = this.expandedElementsAFDB.find(e => e.afdbAccessions === element.afdbAccessions);
    if(ele){
      this.expandedElementsAFDB = this.expandedElementsAFDB.filter(el => el.afdbAccessions !== element.afdbAccessions)
    } else {
      this.expandedElementsAFDB.push(element)
    }
  }

  clickToggleSuperpose(event, accession){
    this.toggleClickedEvent.emit({event, accession})
  }

  isExpandedAFDB(element): boolean {
    const ele = this.expandedElementsAFDB.find(e => e.afdbAccessions === element.afdbAccessions);

    return ele ? true : false;
    // return this.expandedElementsAFDB.has(element);
  }

  isExpansionDetailRowAFDB = (i: number, row) => this.isExpandedAFDB(row);


  convertFormAFDBIds(ids: string[]): string[] {
    return ids.map(id => {
      // Remove heading 'AF-' and any trailing part starting with '-F1'
      return id.replace(/^AF-/, '').replace(/-F1.*$/, '');
    });
  }

  // downloadFrom: string, downloadType: string)
  handleDropdownSelection(event, flag) {
    let tag: string;
    let message: string;
    
    this.downloadService.isDownloadRunningBFVD.set(true);
    if(event === "allresultscsv"){
      this.downloadTableInCSV('AFDB');
      tag = "foldseek_AFDB_download_results";
      message = "Clicks on downloading Table results in AFDB tab";
    }
    if(event === "modelcoordicate"){
      // const convertedIds = this.convertFormAFDBIds(this.selectedValuesBFVD());
      this.downloadService.updateSelectedValuesBFVD(this.selectedValuesBFVD());
      this.downloadService.postFile(this.selectedValuesBFVD(), this.accession, false, 'bfvd');
      tag = "foldseek_AFDB_download_coordinates_pae";
      message = "Clicks on downloading Coordinates and PAE of selected structures in AFDB tab";
    }
    this.selectionBFVD.clear();
    
    this.gaService.eventEmitter('foldseek_download', 'FS_similar_structures', 'click', tag, message);
  }

  clearSelectionDownload(flag): void {
    if(flag === 'afdb'){
      this.selectionBFVD.clear(); // Empties the selection set
      this.downloadService.updateSelectedValuesBFVD([]);
      this.downloadService.updateAllSelectedBFVD(false);
      this.isLimitReachedBFVD = false;
      this.changeDetectorRef.detectChanges();
    }
  }

  checkSelectionLimit(flag) {
    if(flag === "afdb"){
      this.isLimitReachedBFVD = this.selectedValuesBFVD().length >= this.MAX_SELECTION;
    }
  }

  toggleSelectAllEntries(event: Event, flag: string): void {
    if(flag === 'afdb'){
      const checked = (event.target as HTMLInputElement).checked;
      this.downloadService.updateAllSelectedBFVD(checked);
      // Calculate visible rows on the current page using manual pagination variables
      const startIndex = 0;
      const endIndex = Number(this.recordsAFDB);
      const visibleRows = this.afdbStructureDataSource.filteredData.slice(startIndex, endIndex);

      if (this.allSelectedBFVD()) {
        // Add visible rows to the selection if they aren't already selected
        visibleRows.forEach((row) => {
          if (this.selectionBFVD.size < this.MAX_SELECTION) {
            this.selectionBFVD.add(row.targetToShow+"-v2"); // Ensure `row.id` matches your data structure
            const SelectedArr = [...this.selectionBFVD];
            this.downloadService.updateSelectedValuesBFVD(SelectedArr);
          }
        });
      } else {
        // Remove visible rows from selection
        visibleRows.forEach((row) => this.selectionBFVD.delete(row.targetToShow+"-v2"));
        const SelectedArr = [...this.selectionBFVD];
        this.downloadService.updateSelectedValuesBFVD(SelectedArr);
      }
      this.isAllSelectedAFDB();
      this.checkSelectionLimit('afdb');
    } 
  }

  toggleSingleRowSelection(event: Event, elementId: string, flag: string): void {
    if(flag === 'afdb') {
      const checked = (event.target as HTMLInputElement).checked;
  
      if (checked) {
        if (this.selectionBFVD.size < this.MAX_SELECTION) {
          this.selectionBFVD.add(elementId); // Add string to Set
        } else {
          alert('You can select up to 100 rows only.');
        }
      } else {
        this.selectionBFVD.delete(elementId); // Remove string from Set
      }
      const SelectedArr = [...this.selectionBFVD];
      this.downloadService.updateSelectedValuesBFVD(SelectedArr);
      this.isAllSelectedAFDB();
      this.checkSelectionLimit('afdb');
    }
  }
  
  isAllSelectedAFDB(): boolean {
    const startIndex = 0;
    const endIndex = Number(this.recordsAFDB);
    const visibleRows = this.afdbStructureDataSource.filteredData.slice(startIndex, endIndex);
    const isallselectedafdb = visibleRows.every(row => this.selectionBFVD.has(row.targetToShow+"-v2"))
    this.downloadService.updateAllSelectedBFVD(isallselectedafdb);
    return isallselectedafdb; // Check by ID
  }

  isRowCheckboxDisabledAFDB(): boolean {
    return this.selectionBFVD.size >= this.MAX_SELECTION;
  }

  handleAFDBError(species_name_filter, errormsg){
    this.hasAFDBData = -1;
    this.totalAFDBStructure = 0;
    this.foldseekService.updateTotalBFVD(this.totalAFDBStructure);
    this.afdbStructureDataSource = null;
   
    if(species_name_filter != ""){
      this.isAFDBDownloadEnabled = false;
      // this.changeDetectorRef.detectChanges();
      this.hasAFDBData = 1;
      this.errorAFDB = "No species match your search";
      if(this.totalStructure === 0){
        setTimeout(() => {
          this.switchtoTab("afdb");
        }, 0);
      }
      this.afdbZeroResultsMsg="";
      
    }else{
      if(errormsg.startsWith("The search was completed successfully, but no matching results were found")){
        this.afdbZeroResultsMsg = "No matching structures were found in BFVD.";
      }else{
        this.afdbZeroResultsMsg="";
        this.errorAFDB = "No species match your search";
      }
    }
    this.changeDetectorRef.detectChanges();
  }

  switchtoTab(flag) {
    if (this.tabGroup && flag === "afdb" ) {
      this.tabGroup.selectedIndex = 1; 
    } 
  }
  handlePageEvent(e, flag){
  
    const start = ((e.pageIndex * e.pageSize)).toString();
    this.records = e.pageSize.toString();
    this.start = start;

    this.gaService.eventEmitter(
      'foldseek_table_action', 'FS_similar_structures', 'click', 'foldseek_paginate', 'Clicks on the paginations in the Foldseek results table'
    );

    if(flag === "afdb"){
      this.startAFDB = start;
      this.recordsAFDB = e.pageSize.toString();
      this.currentAFDBPage = e.pageIndex;
      let species_name_filter_AFDB = "";
      if(this.filteritemAFDB !== ""){
        species_name_filter_AFDB = this.filteritemAFDB;
      }
      this.checkAndGetBFVDData(this.recordsAFDB, start, this.sort_direction_AFDB, this.sort_column_AFDB, species_name_filter_AFDB);
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
  sortTable(sortState: Sort, flag) {
    let tag = "";
    let gtagmsg = "";
    if(sortState.direction == "asc" && sortState.active == "evalue") {
      tag = "foldseek_evalue_sort_asc";
      gtagmsg = "Clicks on the sort be ascending order for E-value in the Foldseek results table";
    }
    if(sortState.direction == "desc" && sortState.active == "evalue") {
      tag = "foldseek_evalue_sort_desc";
      gtagmsg = "Clicks on the sort be descending order for E-value in the Foldseek results table";
    }

    if(sortState.direction == "asc" && sortState.active == "sequenceIdentity") { 
      tag = "foldseek_sequenceidentity_asc";
      gtagmsg = "Clicks on the sort be ascending order for sequence identity in the Foldseek results table";
    }
    if(sortState.direction == "desc" && sortState.active == "sequenceIdentity") {
      tag = "foldseek_sequenceidentity_desc";
      gtagmsg = "Clicks on the sort be descending order for sequence identity  in the Foldseek results table ";
    }

    const directions = {
      "ASC": "DESC",
      "DESC": "ASC"
    }

    if(flag === "afdb"){
      this.sort_direction_AFDB = directions[sortState.direction.toUpperCase()];
      this.sort_column_AFDB = sortState.active
      let species_name_filter_AFDB;
      if(this.filteritemAFDB !== ""){
        this.species_name_filter_AFDB= this.filteritemAFDB;
      }
      this.checkAndGetBFVDData(this.recordsAFDB, this.startAFDB, this.sort_direction_AFDB, this.sort_column_AFDB, this.species_name_filter_AFDB);
    }
    this.gaService.eventEmitter('foldseek_table_action', 'FS_similar_structures', 'click', tag, gtagmsg);
  }

  filterTable(filterby, flag){
    if(flag === "afdb"){
      this.currentAFDBPage = 0;
      this.filteritemAFDB = filterby;
      this.startAFDB = "0";
      this.species_name_filter_AFDB = filterby;
      this.checkAndGetBFVDData(this.recordsAFDB, "0", this.sort_direction_AFDB, this.sort_column_AFDB, filterby);
    }
    //this.changeDetectorRef.detectChanges();
    this.gaService.eventEmitter('foldseek_table_action', 'FS_similar_structures', 'click', 'foldseek_taxfilter', 'Clicks on the "Taxonomy filter" input box on the Foldseek results table');
  }

  clearFilter(flag){
    if(flag === "afdb"){
      this.currentAFDBPage = 0;
      this.filteritemAFDB = "";
      this.species_name_filter_AFDB = '';
      this.checkAndGetBFVDData(this.recordsAFDB, "0", this.sort_direction_AFDB, this.sort_column_AFDB, "");
    }
    this.changeDetectorRef.detectChanges();
  }

  getApiUrl(flag, records, start, sort_direction, sort_column, species_name_filter){
    let apiUrl = "";
    const configUrl = this.configService.getConfig().searchApiUrl ? this.configService.getConfig().searchApiUrl : "https://test.alphafold.ebi.ac.uk/api/search";

    apiUrl = `${configUrl}?q=${this.afdb_accession}&type=structure`;

    if(flag){
      apiUrl = `${apiUrl}&foldseek_database=`+flag;
    }

    if(records){
      apiUrl = `${apiUrl}&rows=`+records;
    }

    if(start){
      apiUrl = `${apiUrl}&start=${start}`;
    }

    if((sort_column && sort_column != "") && (sort_direction && sort_direction != "")){
      if(sort_column === "evalue")
        apiUrl = apiUrl + '&sort='+sort_column+'+'+sort_direction;
      if(sort_column === "sequenceIdentity")
        apiUrl = apiUrl + '&sort=pident+'+sort_direction;
    }

    if (flag === "afdb50"){
      if(species_name_filter && species_name_filter != ""){
        apiUrl = apiUrl + '&fq=organismScientificName%3A*'+species_name_filter.trim()+'*';
      }
    }
    return apiUrl;
  }

  downloadTableInCSV(flag){
    const auth = this.configService.getConfig().apiKey ? `&key=${this.configService.getConfig().apiKey}` : "";
    let apiUrl;

    if(flag === "AFDB"){
      apiUrl = this.foldseekapiService.getApiUrl("bfvd", "10000", "0", this.sort_direction_AFDB, this.sort_column_AFDB, this.filteritemAFDB);
    }

    this.commonService.getApiDatawithStatus(apiUrl + auth).subscribe(async (response: HttpResponse<any>) => {
      const code = response.status;
      if(code === 200){
        this.isStructureCach = true;
        this.isStructureRunning = false;
        if( response.body.numFound !== 0){
          const data = response.body.docs;
          const similarStructureData = this.transformStructureDataforCSV(data);
          const fileName = `${this.accession}_BFVD_FS`;
          const finalData = XLSX.utils.json_to_sheet(similarStructureData);
          const workbook = {
            SheetNames: ['sheet1'], 
            Sheets: {
              sheet1: { ...finalData }, 
            },
          };
          XLSX.writeFile(workbook, `${fileName}.csv`);
          this.downloadService.updateSelectedValue([]);
          this.downloadService.updateAllSelected(false);
         
          if(flag === "AFDB"){
            this.downloadService.isDownloadRunningBFVD.set(false);
            this.downloadService.isDownloadDoneBFVD.set(true);
            this.clearSelectionDownload("afdb")
            if(this.downloadService.isDownloadDoneBFVD) {
              setTimeout(() => {
                this.downloadService.isDownloadDoneBFVD.set(false);
              }, 7000); 
            }
          }
          this.changeDetectorRef.detectChanges();
        }else{
          if(flag === "AFDB"){
            this.isAFDBDownloadEnabled = false;
          }
          
        }
      }
    },
    (error) => {
      const code = error.status;
      if(code === 404){
        if(flag === "AFDB"){
          this.isAFDBDownloadEnabled = false;
        }
        this.changeDetectorRef.detectChanges();
      }
    });
  }

  public checkAndGetBFVDData(records="", start="", sort_direction, sort_column, species_name_filter=""){
    const auth = this.configService.getConfig().apiKey ? `&key=${this.configService.getConfig().apiKey}` : "";
  
    const apiUrl = this.foldseekapiService.getApiUrl("bfvd", records, start, sort_direction, sort_column, species_name_filter);

    this.isAFDBLoading = true;

    this.commonService.getApiDatawithStatus(apiUrl + auth).subscribe(async (response: HttpResponse<any>) => {
      const code = await Number(response.status);
      if(code === 202){
        this.foldseekapiService.updateisBFVDLoading(true);
        this.isAFDBFoldseekCach = true;
        this.isStructureCach = true;
        this.isStructureRunning = true;
        if(response.body.message && (response.body.message.startsWith("Foldseek search job is currently running") || response.body.message.startsWith("Initiating new Foldseek search")))
        {
          this.isStructureRunning = true;
          this.subTimeout = setTimeout(() => {
          if(this.isAFDBLoading) this.checkAndGetBFVDData(records, start, sort_direction, sort_column, species_name_filter);
          }, 15000);
        }
      }
      if(code === 200){
        this.foldseekapiService.updateisBFVDLoading(false);
        this.changeDetectorRef.detectChanges();
        this.isAFDBDownloadEnabled = true;
        this.isStructureCach = true;
        this.isStructureRunning = false;
        if( response.body.numFound !== 0){
          const data = response.body.docs;
          this.hasStructureData = 1;
          this.hasAFDBData = 1;
          this.errorAFDB = "";
          this.totalAFDBStructure = response.body.numFound;
          this.foldseekService.updateTotalBFVD(response.body.numFound);
          const similarStructureData = this.transformAFDBStructureData(data);
          this.isAFDBLoading = false;
         
          this.afdbStructureDataSource = new MatTableDataSource<SimilarStructure>(similarStructureData);    
          const isallselected = this.isAllSelectedAFDB();
          this.downloadService.updateAllSelectedBFVD(isallselected);
          this.afdbStructureDataSource.paginator = this.paginator3;
        }
        if( response.body.numFound === 0){
          this.foldseekService.updateTotalBFVD(0);
          this.errorAFDB = "No matching structures were found in BFVD.";
        }
      }
      this.changeDetectorRef.detectChanges();
    },
    (error) => {
      const code = error.status;
      this.isAFDBLoading = false;
      if(code === 404){
        this.foldseekapiService.updateisBFVDLoading(false);
        this.isAFDBDownloadEnabled = false;
        this.isStructureRunning = false;
        this.hasAFDBData = -1;
        this.totalAFDBStructure = 0;
        this.foldseekService.updateTotalBFVD(0);
        this.afdbStructureDataSource = null;
        this.changeDetectorRef.detectChanges();

        if(error.error.message === "Foldseek was not run for this accession."){
          this.foldseekapiService.startStructureSearch();
          this.isAFDBFoldseekCach = false;
        }else if(error.error.message === "The search was completed successfully, but no matching results were found"){
          this.isAFDBFoldseekCach = true;
          this.handleAFDBError("", error.error.message);
        }else if(species_name_filter != ""){
          this.handleAFDBError(species_name_filter, error.error.message);
        }
      }
      if(code === 400){
        this.foldseekapiService.updateisBFVDLoading(false);
        this.isStructureCach = false;
        this.isStructureRunning = false;
        this.isStructureFail = true;
        this.isAFDBDownloadEnabled = false;
        this.changeDetectorRef.detectChanges();
        this.isDatabaseErrorBFVD = true;
      }
      if(code === 422 || code === 302 || code === 500 || code === 0 || code === 429){
        this.foldseekapiService.updateisBFVDLoading(false);
        this.isStructureCach = false;
        this.isStructureRunning = false;
        this.isStructureFail = true;
        this.isAFDBDownloadEnabled = false;
        this.changeDetectorRef.detectChanges();
      }
    });
  }
  
  getTitle(accession, reviewedStatus, referenceLabel) {
    let tempTitle = "Unavailable";
      
    if(accession){
      if(reviewedStatus && referenceLabel) {
        tempTitle =  `${accession}*${referenceLabel}*${reviewedStatus}`;
      }
      if(reviewedStatus && !referenceLabel){
        tempTitle =  `${accession}*${referenceLabel}*${reviewedStatus}`;
      }
      if(!reviewedStatus && referenceLabel){
        tempTitle =  `${accession}*${referenceLabel}*${reviewedStatus}`;
      }
      if(!reviewedStatus && !referenceLabel){
        tempTitle =  `${accession}*${referenceLabel}*${reviewedStatus}`;
      }
    }

    return tempTitle;
  }

  getLink(database, target) {
    if (database === "pdb") {
      const [entry, ,protein] = target.split("_");
      return protein ? 
        `${this.configService.getConfig().pdbeBaseApiUrl}/entry/pdb/${entry}/protein/${protein}` : 
        `${this.configService.getConfig().pdbeBaseApiUrl}/entry/pdb/${entry}`;
    }
    return `/entry/${target}`;
  }
  
  transformAFDBStructureData(data) {
    const similarClusterData = [];
    if(data){
    const databaseInfo = {};
    for (let i = 0; i < data.length; i++) {
      similarClusterData.push({
        "refLinkId": this.getLink(data[i].database, data[i].target),
        "afdbAccessions": this.getTitle(data[i].target, data[i].isReviewed, data[i].isReferenceProteome),
        "targetToShow": data[i].modelEntityId,
        "targetToDownload": data[i].modelEntityId+"-v2",
        "uniprotDescriptions": data[i].uniprotDescription,
        "speciesNames": data[i].organismScientificName ? data[i].organismScientificName : "",
        "sequenceIdentity": data[i].pident ? data[i].pident : "N/A",
        "sequenceLength": data[i].uniprotEnd ? `1-${data[i].uniprotEnd}` : "N/A",
        "evalue": (data[i].evalue != null && data[i].evalue !== "") ? Number(data[i].evalue).toExponential(2) : "N/A",
        "averagePlddt": data[i].globalMetricValue ?  data[i].globalMetricValue : "N/A",
        "alighin3D": this.superposeData.some(entry => entry.accession === data[i].target),
        "expanded": false,
        "hsps" : {
          "current_entry": this.afdb_accession,
          "accession": data[i].target,
          "query_sequence": data[i].qaln,
          "match_sequence": data[i].qaln,
          "match_accession": data[i].taln,
          "qstart": data[i].qstart,
          "qend": data[i].qend,
          "tstart": data[i].tstart,
          "tend": data[i].tend,
          "sequence_stats": [],
          "targetToShow": data[i].entryId,
        }
      });
      data[i].database = "afdb50";
      const foldseekWithDesc = { 
        ...data[i], 
        targetToShow: data[i].entryId,
        desc: data[i].uniprotDescription, 
        refLinkId: this.getLink(data[i].database, data[i].target),
      };

      foldseekWithDesc.tstructure = {
        "url": `https://alphafold.ebi.ac.uk/files/${data[i].modelEntityId}-model_v2.bcif`,
        "format": 'cif',
        "binary": true,
      }
      
      databaseInfo[data[i].target] = foldseekWithDesc
      this.foldseekapiService.apiData.set(databaseInfo);
    }
    return similarClusterData;
  }}

  transformStructureDataforCSV(data) {
    const tableCSVData = [];
    if(data){
    for (let i = 0; i < data.length; i++) {

      let dataObj: any = {
        "Sr.No.": i+1
      }

      dataObj["AFDB accession"] =  data[i].entryId
      dataObj["Description"]=  data[i].uniprotDescription ? data[i].uniprotDescription : "N/A" 
      dataObj["Species"] = data[i].organismScientificName ? data[i].organismScientificName : "N/A"
      dataObj["Residue Range"] =  data[i].uniprotEnd ?  `1-${data[i].uniprotEnd}` : "N/A"
      dataObj["E-value"] = data[i].evalue ? (data[i].evalue.toExponential(2)).toString() : "N/A"
      dataObj["Sequence identity"] = data[i].pident ? data[i].pident+"%" : "N/A"
      dataObj["Reviewed status"] = data[i].isReviewed,
      dataObj["Reference proteome status"] = data[i].isReferenceProteome,
      dataObj["Average pLDDT"] = data[i].globalMetricValue;
      
      dataObj = {
        ...dataObj,
        "Query start position" : data[i].qstart,
        "Query end position" : data[i].qend,
        "Aligned query sequence with gaps" : data[i].qaln,
        
        "Target start position" : data[i].tstart,
        "Target end position" : data[i].tend,
        "Aligned target sequence with gaps": data[i].taln,
      }
      tableCSVData.push(dataObj);
    }
    return tableCSVData;
  }}

}
